import axios from 'axios';

/**
 * Configuration de l'API
 * 
 * Détection automatique de l'environnement :
 * - En local (localhost/127.0.0.1) : utilise http://127.0.0.1:8000/api
 * - En production : utilise https://apihanafia.xeweultech.com/api
 * 
 * Vous pouvez forcer une URL avec la variable d'environnement REACT_APP_API_URL
 */
const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (isProduction 
    ? 'https://apihanafiya.xeweultech.com/api' 
    : 'http://127.0.0.1:8000/api');

// Base pour les fichiers médias (backend), dérivée de l'API
export const MEDIA_BASE_URL = API_BASE_URL.replace(/\/?api\/?$/, '');

// Helper pour construire une URL absolue vers un média backend
export const toMediaUrl = (url?: string): string => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  if (url.startsWith('/')) return `${MEDIA_BASE_URL}${url}`;
  return `${MEDIA_BASE_URL}/${url}`;
};

// Log pour déboguer (uniquement en développement)
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 Configuration API:', {
    environment: isProduction ? 'Production' : 'Développement',
    apiUrl: API_BASE_URL,
    hostname: window.location.hostname,
  });
}

// Créer l'instance axios
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token JWT
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Ne pas définir Content-Type pour FormData (axios le fait automatiquement)
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Si erreur 401 et pas encore tenté de refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refresh_token');
        if (refreshToken) {
          const response = await axios.post(`${API_BASE_URL}/auth/token/refresh/`, {
            refresh: refreshToken,
          });

          const { access } = response.data;
          localStorage.setItem('access_token', access);

          originalRequest.headers.Authorization = `Bearer ${access}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        // Refresh token invalide, déconnexion
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user');
        window.location.href = '/#/login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;

